import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, List, LogOut, Plus, Users, BarChart2,
  Search, Edit2, Trash2, CheckCircle, XCircle, Phone, Mail, X, Building2, ArrowLeft
} from 'lucide-react';
import '../demo-professional.css';

const revendedoresIniciales = [
  { id: 1, nombre: 'El Tano',        contacto: 'Diego Ferreira',   telefono: '099 123 456', email: 'eltano@email.com',        activo: true,  ofertas: 45, adjudicaciones: 5 },
  { id: 2, nombre: 'Los Pinos',      contacto: 'Marcelo Suárez',   telefono: '099 234 567', email: 'lospinos@email.com',      activo: true,  ofertas: 38, adjudicaciones: 4 },
  { id: 3, nombre: 'AutoMax',        contacto: 'Roberto Gómez',    telefono: '091 345 678', email: 'automax@email.com',       activo: true,  ofertas: 52, adjudicaciones: 6 },
  { id: 4, nombre: 'Super Autos',    contacto: 'Carlos Bentancur', telefono: '098 456 789', email: 'superautos@email.com',    activo: false, ofertas: 12, adjudicaciones: 1 },
  { id: 5, nombre: 'La Boutique',    contacto: 'Andrés Paz',       telefono: '099 567 890', email: 'boutique@email.com',      activo: true,  ofertas: 28, adjudicaciones: 3 },
  { id: 6, nombre: 'El Corral',      contacto: 'Sebastián Díaz',   telefono: '092 678 901', email: 'elcorral@email.com',      activo: true,  ofertas: 33, adjudicaciones: 2 },
  { id: 7, nombre: 'AutoVip',        contacto: 'Gonzalo Torres',   telefono: '098 789 012', email: 'autovip@email.com',       activo: true,  ofertas: 19, adjudicaciones: 2 },
  { id: 8, nombre: 'Express Cars',   contacto: 'Federico Ruiz',    telefono: '099 890 123', email: 'expresscars@email.com',   activo: true,  ofertas: 24, adjudicaciones: 1 },
  { id: 9, nombre: 'Premium Motors', contacto: 'José Lima',        telefono: '091 901 234', email: 'premium@email.com',       activo: true,  ofertas: 41, adjudicaciones: 5 },
  { id: 10, nombre: 'Sur Autos',     contacto: 'Daniel Cardoso',   telefono: '098 012 345', email: 'surautos@email.com',      activo: false, ofertas: 8,  adjudicaciones: 0 },
  { id: 11, nombre: 'Norte Motors',  contacto: 'Matías Vega',      telefono: '099 123 000', email: 'nortemotors@email.com',   activo: true,  ofertas: 16, adjudicaciones: 1 },
  { id: 12, nombre: 'Centro Autos',  contacto: 'Pablo Sosa',       telefono: '092 234 000', email: 'centroautos@email.com',   activo: true,  ofertas: 22, adjudicaciones: 3 },
];

const emptyForm = { nombre: '', contacto: '', telefono: '', email: '', activo: true };

function DemoNav({ active }) {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('demo_authenticated');
    navigate('/propuesta/demo');
  };
  const tabs = [
    { id: 'dashboard',    label: 'Dashboard',    icon: <LayoutDashboard size={15} />, path: '/propuesta/demo/dashboard' },
    { id: 'publicaciones', label: 'Publicaciones', icon: <List size={15} />, path: '/propuesta/demo/publicaciones' },
    { id: 'revendedores',  label: 'Revendedores',  icon: <Users size={15} />, path: '/propuesta/demo/revendedores' },
    { id: 'reportes',      label: 'Reportes',      icon: <BarChart2 size={15} />, path: '/propuesta/demo/reportes' },
  ];
  return (
    <>
      <header className="demo-header sticky top-0 z-20">
        <div className="px-4 sm:px-6 py-3.5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)' }}>
              <Building2 className="text-white" size={18} />
            </div>
            <div>
              <h1 className="text-base font-bold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>Sistema de Tasación</h1>
              <p className="text-xs" style={{ color: '#94a3b8' }}>Vladimir & Aerocar</p>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <button onClick={() => navigate('/propuesta')} className="flex items-center gap-1.5 px-3 py-2 text-sm rounded-lg transition hover:bg-white/5" style={{ color: '#94a3b8' }} data-testid="demo-back-to-propuesta" title="Volver a la propuesta">
              <ArrowLeft size={15} /><span className="hidden sm:inline">Propuesta</span>
            </button>
            <button onClick={handleLogout} className="flex items-center gap-2 px-3 py-2 text-sm rounded-lg" style={{ color: '#94a3b8' }}>
              <LogOut size={15} /><span className="hidden sm:inline">Salir</span>
            </button>
          </div>
        </div>
      </header>
      <nav style={{ background: 'white', borderBottom: '1px solid #e2e8f0' }}>
        <div className="px-4 sm:px-6 py-2 flex items-center gap-1 sm:gap-2 overflow-x-auto">
          {tabs.map(tab => (
            <button key={tab.id} onClick={() => navigate(tab.path)}
              className={`flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-lg whitespace-nowrap transition ${active === tab.id ? 'text-orange-600 bg-orange-50' : 'text-gray-500 hover:text-gray-800 hover:bg-gray-50'}`}>
              {tab.icon}<span>{tab.label}</span>
            </button>
          ))}
          <button onClick={() => navigate('/propuesta/demo/nueva')}
            className="flex items-center gap-1.5 px-4 py-2 text-sm font-semibold text-white rounded-lg ml-auto whitespace-nowrap"
            style={{ background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)' }}>
            <Plus size={15} /><span>Nueva</span>
          </button>
        </div>
      </nav>
    </>
  );
}

export default function DemoRevendedores() {
  const [revendedores, setRevendedores] = useState(revendedoresIniciales);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(null); // null | 'add' | 'edit'
  const [form, setForm] = useState(emptyForm);
  const [editId, setEditId] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  const filtered = revendedores.filter(r =>
    r.nombre.toLowerCase().includes(search.toLowerCase()) ||
    r.contacto.toLowerCase().includes(search.toLowerCase())
  );

  const openAdd = () => { setForm(emptyForm); setModal('add'); };
  const openEdit = (r) => { setForm({ nombre: r.nombre, contacto: r.contacto, telefono: r.telefono, email: r.email, activo: r.activo }); setEditId(r.id); setModal('edit'); };
  const closeModal = () => { setModal(null); setEditId(null); };

  const handleSave = () => {
    if (!form.nombre.trim()) return;
    if (modal === 'add') {
      setRevendedores(prev => [...prev, { ...form, id: Date.now(), ofertas: 0, adjudicaciones: 0 }]);
    } else {
      setRevendedores(prev => prev.map(r => r.id === editId ? { ...r, ...form } : r));
    }
    closeModal();
  };

  const handleDelete = (id) => {
    setRevendedores(prev => prev.filter(r => r.id !== id));
    setDeleteConfirm(null);
  };

  const toggleActivo = (id) => {
    setRevendedores(prev => prev.map(r => r.id === id ? { ...r, activo: !r.activo } : r));
  };

  const activos = revendedores.filter(r => r.activo).length;
  const totalOfertas = revendedores.reduce((s, r) => s + r.ofertas, 0);

  return (
    <div className="min-h-screen" style={{ background: '#f1f5f9' }}>
      <DemoNav active="revendedores" />

      <main className="px-4 sm:px-6 py-6 max-w-7xl mx-auto">
        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 mb-6">
          {[
            { label: 'Total Revendedores', value: revendedores.length, color: '#3b82f6', bg: '#eff6ff' },
            { label: 'Activos',            value: activos,             color: '#22c55e', bg: '#f0fdf4' },
            { label: 'Total Ofertas',      value: totalOfertas,        color: '#f97316', bg: '#fff7ed' },
          ].map((s, i) => (
            <div key={i} className="demo-card p-4 text-center">
              <div className="text-2xl font-bold mb-1" style={{ fontFamily: 'Outfit, sans-serif', color: s.color }}>{s.value}</div>
              <div className="text-xs" style={{ color: '#64748b' }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Table */}
        <div className="demo-card overflow-hidden">
          <div className="px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3" style={{ borderBottom: '1px solid #e2e8f0' }}>
            <h2 className="text-base font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
              Revendedores ({filtered.length})
            </h2>
            <div className="flex items-center gap-3 w-full sm:w-auto">
              <div className="relative flex-1 sm:flex-none">
                <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: '#94a3b8' }} />
                <input
                  type="text"
                  placeholder="Buscar..."
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  className="w-full sm:w-56 pl-8 pr-3 py-2 text-sm border rounded-lg outline-none"
                  style={{ borderColor: '#e2e8f0', color: '#334155' }}
                />
              </div>
              <button
                onClick={openAdd}
                className="flex items-center gap-1.5 px-4 py-2 text-sm font-semibold text-white rounded-lg whitespace-nowrap"
                style={{ background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)' }}
              >
                <Plus size={14} /> Agregar
              </button>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                <tr>
                  {['Empresa', 'Contacto', 'Teléfono', 'Estado', 'Ofertas', 'Adj.', 'Acciones'].map((h, i) => (
                    <th key={i} className="px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider" style={{ color: '#64748b' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody style={{ background: 'white' }}>
                {filtered.map((r, idx) => (
                  <tr key={r.id} style={{ borderBottom: idx < filtered.length - 1 ? '1px solid #f8fafc' : 'none' }} className="hover:bg-gray-50 transition">
                    <td className="px-5 py-3.5 whitespace-nowrap">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white" style={{ background: r.activo ? '#f97316' : '#94a3b8' }}>
                          {r.nombre.charAt(0)}
                        </div>
                        <span className="text-sm font-semibold" style={{ color: '#0f172a' }}>{r.nombre}</span>
                      </div>
                    </td>
                    <td className="px-5 py-3.5 whitespace-nowrap text-sm" style={{ color: '#475569' }}>{r.contacto}</td>
                    <td className="px-5 py-3.5 whitespace-nowrap text-sm font-mono" style={{ color: '#64748b' }}>{r.telefono}</td>
                    <td className="px-5 py-3.5 whitespace-nowrap">
                      <button onClick={() => toggleActivo(r.id)} className="flex items-center gap-1.5 transition">
                        {r.activo
                          ? <span className="demo-badge-success inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold"><CheckCircle size={11} /> Activo</span>
                          : <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold" style={{ background: '#f1f5f9', color: '#94a3b8' }}><XCircle size={11} /> Inactivo</span>
                        }
                      </button>
                    </td>
                    <td className="px-5 py-3.5 whitespace-nowrap text-sm font-bold" style={{ color: r.ofertas > 30 ? '#f97316' : '#0f172a' }}>{r.ofertas}</td>
                    <td className="px-5 py-3.5 whitespace-nowrap text-sm font-medium" style={{ color: '#22c55e' }}>{r.adjudicaciones}</td>
                    <td className="px-5 py-3.5 whitespace-nowrap">
                      <div className="flex items-center gap-2">
                        <button onClick={() => openEdit(r)} className="p-1.5 rounded hover:bg-gray-100 transition" title="Editar">
                          <Edit2 size={14} style={{ color: '#3b82f6' }} />
                        </button>
                        <button onClick={() => setDeleteConfirm(r.id)} className="p-1.5 rounded hover:bg-red-50 transition" title="Eliminar">
                          <Trash2 size={14} style={{ color: '#ef4444' }} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>

      {/* Modal Add/Edit */}
      {modal && (
        <>
          <div className="fixed inset-0 bg-black/40 z-40" onClick={closeModal} />
          <div className="fixed inset-0 flex items-center justify-center z-50 px-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
              <div className="flex items-center justify-between mb-5">
                <h3 className="text-lg font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#0f172a' }}>
                  {modal === 'add' ? 'Agregar Revendedor' : 'Editar Revendedor'}
                </h3>
                <button onClick={closeModal} className="p-1.5 rounded hover:bg-gray-100"><X size={18} /></button>
              </div>
              <div className="space-y-4">
                {[
                  { label: 'Empresa / Nombre', key: 'nombre', placeholder: 'Ej: Auto Sánchez' },
                  { label: 'Nombre de contacto', key: 'contacto', placeholder: 'Ej: Juan Sánchez' },
                  { label: 'Teléfono', key: 'telefono', placeholder: 'Ej: 099 000 000' },
                  { label: 'Email', key: 'email', placeholder: 'Ej: juan@email.com' },
                ].map(f => (
                  <div key={f.key}>
                    <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: '#64748b' }}>{f.label}</label>
                    <input
                      type="text"
                      placeholder={f.placeholder}
                      value={form[f.key]}
                      onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                      className="w-full px-4 py-2.5 text-sm border rounded-lg outline-none focus:border-orange-400 transition"
                      style={{ borderColor: '#e2e8f0', color: '#334155' }}
                    />
                  </div>
                ))}
                <div className="flex items-center gap-3">
                  <label className="text-xs font-semibold uppercase tracking-wider" style={{ color: '#64748b' }}>Estado</label>
                  <button
                    onClick={() => setForm(prev => ({ ...prev, activo: !prev.activo }))}
                    className={`relative w-11 h-6 rounded-full transition-colors ${form.activo ? 'bg-orange-500' : 'bg-gray-300'}`}
                  >
                    <div className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${form.activo ? 'left-5' : 'left-0.5'}`} />
                  </button>
                  <span className="text-sm" style={{ color: form.activo ? '#f97316' : '#94a3b8' }}>{form.activo ? 'Activo' : 'Inactivo'}</span>
                </div>
              </div>
              <div className="flex gap-3 mt-6">
                <button onClick={closeModal} className="flex-1 py-2.5 text-sm font-semibold border rounded-lg transition hover:bg-gray-50" style={{ borderColor: '#e2e8f0', color: '#64748b' }}>
                  Cancelar
                </button>
                <button
                  onClick={handleSave}
                  className="flex-1 py-2.5 text-sm font-semibold text-white rounded-lg transition"
                  style={{ background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)' }}
                >
                  {modal === 'add' ? 'Agregar' : 'Guardar'}
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Confirm Delete */}
      {deleteConfirm && (
        <>
          <div className="fixed inset-0 bg-black/40 z-40" onClick={() => setDeleteConfirm(null)} />
          <div className="fixed inset-0 flex items-center justify-center z-50 px-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 text-center">
              <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
                <Trash2 size={22} style={{ color: '#ef4444' }} />
              </div>
              <h3 className="text-lg font-bold mb-2" style={{ color: '#0f172a' }}>¿Eliminar revendedor?</h3>
              <p className="text-sm mb-5" style={{ color: '#64748b' }}>Esta acción no se puede deshacer.</p>
              <div className="flex gap-3">
                <button onClick={() => setDeleteConfirm(null)} className="flex-1 py-2.5 text-sm font-semibold border rounded-lg" style={{ borderColor: '#e2e8f0', color: '#64748b' }}>Cancelar</button>
                <button onClick={() => handleDelete(deleteConfirm)} className="flex-1 py-2.5 text-sm font-semibold text-white rounded-lg bg-red-500 hover:bg-red-600 transition">Eliminar</button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
